import { z } from 'zod';

const REPORTABLE_WEIGHT_SCALE = 10;
const REPORTABLE_WEIGHT_EPSILON = 1e-6;

export const ReportableWeightLbSchema = z
  .number()
  .min(0)
  .refine(isReportableWeightLb, {
    message: 'Official/reportable weights must be rounded to the nearest 0.1 lb.',
  });

export function isReportableWeightLb(value: number): boolean {
  if (!Number.isFinite(value)) {
    return false;
  }
  const scaled = value * REPORTABLE_WEIGHT_SCALE;
  return Math.abs(scaled - Math.round(scaled)) <= REPORTABLE_WEIGHT_EPSILON;
}
